import { getStoredAccessCenterCustomerUuid } from "../../Pages/Management/Access/accessCenterUtils";
import ReferenceModel from "../../Models/ReferenceModel";

export const ASK_AI_ACTIVE_CUSTOMER_KEY = "ask-ai.active-customer";
export const CONVERSATION_HISTORY_PAGE_SIZE = 20;
export const CONVERSATION_HISTORY_PREFETCH_ROWS = 5;

export function getStoredAskAiCustomerUuid(): string | null {
	try {
		return sessionStorage.getItem(ASK_AI_ACTIVE_CUSTOMER_KEY);
	} catch {
		return null;
	}
}

export function setStoredAskAiCustomerUuid(customerUuid: string | null): void {
	try {
		if (customerUuid) {
			sessionStorage.setItem(ASK_AI_ACTIVE_CUSTOMER_KEY, customerUuid);
			return;
		}
		sessionStorage.removeItem(ASK_AI_ACTIVE_CUSTOMER_KEY);
	} catch {
		// sessionStorage may be unavailable
	}
}

export function conversationTitleFromMessage(message: string): string {
	const trimmed = message.trim();
	if (trimmed.length <= 100) {
		return trimmed;
	}
	return `${trimmed.substring(0, 97)}...`;
}

export function resolveAskAiComposerCustomer(
	customerSelectItems: ReferenceModel[],
	options?: {
		filterCustomerUuid?: string | null;
		conversationCustomer?: ReferenceModel | null;
	},
): ReferenceModel | null {
	const candidates = [
		getStoredAskAiCustomerUuid(),
		getStoredAccessCenterCustomerUuid(),
		options?.filterCustomerUuid ?? null,
		options?.conversationCustomer?.uuid ?? null,
	];

	for (const uuid of candidates) {
		if (!uuid) {
			continue;
		}
		const match = customerSelectItems.find((customer) => customer.uuid === uuid);
		if (match) {
			return match;
		}
	}

	if (customerSelectItems.length === 1) {
		return customerSelectItems[0];
	}

	return options?.conversationCustomer ?? null;
}
